import { createContext } from 'react';
import type { LoginContextType } from '../types';

export const LoginContext = createContext<LoginContextType>({ isLogin: false, setIsLogin: () => {} });
